document.addEventListener("DOMContentLoaded", function () {
  const logo = document.querySelector(".footer_svg");
  const footer = document.querySelector(".footer_container");
  if (!logo || !footer) return;

  function updateLogoPosition() {
    const footerRect = footer.getBoundingClientRect();
    const logoHeight = logo.offsetHeight;
    const windowHeight = window.innerHeight;

    // If the top of the footer is below the viewport, keep logo fixed
    if (footerRect.top > windowHeight) {
      logo.style.position = "fixed";
      logo.style.left = "50%";
      logo.style.transform = "translate(-50%, 35%)";
      logo.style.bottom = "0";
      logo.style.top = "";
    } else {
      // Footer is entering the viewport, anchor logo to footer
      logo.style.position = "absolute";
      logo.style.left = "50%";
      logo.style.transform = "translate(-50%, -70%)";
      logo.style.bottom = "";
      logo.style.top = `${footer.offsetTop}px`;
    }
  }

  updateLogoPosition();
  window.addEventListener("scroll", updateLogoPosition, { passive: true });
  window.addEventListener("resize", updateLogoPosition);

  // --- Footer link logic goes here ---
  function waitForMenuAndClick(blockId, tries = 0) {
    const header = document.querySelector(".header");
    const headerMenuLink = document.querySelector(
      `.menu_link[data-block-id="${blockId}"]`
    );
    // Check if menu is open and link is visible
    if (
      header.classList.contains("expanded") &&
      headerMenuLink &&
      headerMenuLink.offsetParent !== null
    ) {
      // Use a real user event for best compatibility
      headerMenuLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    } else if (tries < 20) {
      setTimeout(() => waitForMenuAndClick(blockId, tries + 1), 50);
    } else {
      console.log("Menu did not open in time or menu link not found.");
    }
  }

  const footerLinks = document.querySelectorAll(
    ".footer_menu_link[data-block-id]"
  );

  footerLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      let blockId = link.getAttribute("data-block-id");
      if (!blockId) return;
      blockId = blockId.toLowerCase();

      // Find a menu link with a case-insensitive match
      const headerMenuLink = Array.from(
        document.querySelectorAll(".menu_link[data-block-id]")
      ).find(
        (el) =>
          (el.getAttribute("data-block-id") || "").toLowerCase() === blockId
      );

      if (!headerMenuLink) return; // No matching menu link, do nothing

      const menuButton = document.querySelector(".header_left");
      const header = document.querySelector(".header");
      if (!header.classList.contains("expanded")) {
        menuButton.click();
      }

      setTimeout(() => {
        // Double-check in case menu just opened
        const headerMenuLinkNow = Array.from(
          document.querySelectorAll(".menu_link[data-block-id]")
        ).find(
          (el) =>
            (el.getAttribute("data-block-id") || "").toLowerCase() === blockId
        );
        if (headerMenuLinkNow) {
          headerMenuLinkNow.click();
        }
      }, 400);
    });
  });
});
